import { motion } from "framer-motion";
import { Cursor, Path, MapTrifold, CheckCircle } from "@phosphor-icons/react";
import SectionEyebrow from "@/components/shared/SectionEyebrow";

const STEPS = [
  { n: "01", icon: Cursor, color: "#14B8A6", title: "Place your order", desc: "Open the IslandHop app, pick your service, browse merchants and confirm in seconds." },
  { n: "02", icon: Path, color: "#FF7A45", title: "Driver accepts", desc: "Our smart dispatch routes the closest, highest-rated independent driver to your order." },
  { n: "03", icon: MapTrifold, color: "#D4AF37", title: "Track in real time", desc: "Live GPS, accurate ETAs and in-app chat — you always know exactly where your delivery is." },
  { n: "04", icon: CheckCircle, color: "#14B8A6", title: "Receive delivery", desc: "Contactless drop-off, secure handover, instant receipt. Rate your experience to keep us sharp." },
];

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-24 lg:py-32 border-t border-ih-line" data-testid="home-how">
      <div className="absolute inset-0 ih-grid-bg opacity-50 [mask-image:linear-gradient(180deg,#000,transparent_70%)]" />
      <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-16 space-y-4">
          <SectionEyebrow label="How it works" color="neon" className="mx-auto" />
          <h2 className="font-display font-extrabold text-4xl lg:text-6xl text-white">
            Four taps.<br />
            <span className="text-white/40">One reliable</span> <span className="text-ih-neon">delivery.</span>
          </h2>
        </div>

        <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-12 left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-ih-line2 to-transparent" />
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`how-step-${s.n}`}
                className="relative bg-ih-surface border border-ih-line rounded-2xl p-7 group hover:border-white/20 transition"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="w-12 h-12 rounded-xl bg-black/40 border border-ih-line2 grid place-items-center" style={{ color: s.color }}>
                    <Icon weight="duotone" size={22} />
                  </span>
                  <span className="font-mono text-xs text-white/40">STEP {s.n}</span>
                </div>
                <h3 className="font-display font-bold text-xl text-white mb-2">{s.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
